import React from 'react';
import Header from '../components/landing/Header';
import Hero from '../components/landing/Hero';
import Problem from '../components/landing/Problem';
import About from '../components/landing/About';
import Features from '../components/landing/Features';
import Benefits from '../components/landing/Benefits';
import Plans from '../components/landing/Plans';
// import Blog from '../components/landing/Blog';
import Invitation from '../components/landing/Invitation';
import LoggedAreaCTA from '../components/landing/LoggedAreaCTA';
import Footer from '../components/landing/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#FDFCF8] text-[#1A1A1A] selection:bg-purple-200">
      <Header />
      <main>
        <Hero />
        {/* <Problem /> */}
        <About />
        <Features />
        <Benefits />
        <Plans />
        {/* <Blog /> */}
        {/* <Invitation /> */}
        <LoggedAreaCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
